<template>
  <public-layout class="page-dashboard">
    <div class="container">
      <div class="section is-left-aligned">
        <h1>My Classroom</h1>

        <template v-if="hasManualAccess">
          <Loader v-if="!manualLoaded"></Loader>
          <div class="dashboard-manual card has-border-dark" v-else>
            <div class="card-content">
              <h4 class="name">Teacher's Manual</h4>
              <p>Over 1000 lessons, 200 story time readings, 120 circle time activities, 60 circle time songs and much more!</p>
              <br>
              <!-- <a class="button button-secondary button-medium" :href="manual.url" target="_blank">Open the Teacher's Manual</a> -->

              <a class="button button-secondary button-medium" href="/manual/home/?lang=1">Open the Teacher's Manual</a>

              <!-- <a class="button button-primary button-small" href="/manual/home/?lang=1">English</a> -->
              <!-- <a class="button button-primary button-small" href="/manual/home/?lang=2">Suomi</a> -->
              <!-- <a class="button button-primary button-small" href="/manual/home/?lang=4">Français</a> -->
              <!-- <a class="button button-primary button-small" href="/manual/home/?lang=7">العربية</a> -->
            </div>
          </div>
        </template>

        <!-- <h3>Your Fun Learning Progress</h3>
        <p>Continue your Fun Learning journey from where you left it or access previous programs from here.</p>

        <Loader v-if="!coursesLoaded"></Loader>
        <template v-else>
          <div class="dashboard-courses is-empty" v-if="!courses.length">
            <p>You’ve got no courses yet. But hey, did you know we have the right one for you?</p>
            <Button size="medium" :to="{ name: 'future-explorers' }">View Courses</Button>
          </div>
          <div class="dashboard-courses columns is-multiline" v-else>
            <div class="column is-half" v-for="course in courses" :key="course.id">
              <div class="dashboard-course card has-border-dark">
                <div class="card-content">
                  <h4 class="name">{{ course.name }}</h4>
                  <p class="description">{{ course.description }}</p>
                </div>
                <div class="card-content">
                  <Button type="secondary" size="medium" :to="{ name: 'course', params: { courseId: course.id, langId: currentLanguageId } }">Continue</Button>
                </div>
              </div>
            </div>
          </div>
        </template> -->

        <h3>Saved resources</h3>
        <p>Get quick access to all the resources you have bookmarked from here.</p>

        <Loader v-if="!resourcesLoaded"></Loader>
        <template v-else>
          <div class="dashboard-resources is-empty" v-if="!resources.length">
            <p>Mmm, no resources here. But you can start your downloading spree cause they’re free!</p>
            <Button size="medium" :to="{ name: 'resources' }">Explore Resources</Button>
          </div>
          <resource-thumbnail-list :resources="resources" class="dashboard-resources" v-else></resource-thumbnail-list>
        </template>
      </div>
    </div>
  </public-layout>
</template>

<script>
import UserService from '@/services/UserService'
import Utils from '@/utils/Utils'

import PublicLayout from '@/layouts/PublicLayout'
import Button from '@/components/Button'
import Loader from '@/components/Loader'
import ResourceThumbnailList from '@/components/ResourceThumbnailList'
import { mapGetters } from 'vuex'

export default {
  components: {
    PublicLayout,
    Button,
    Loader,
    ResourceThumbnailList
  },

  created () {
    this.user = this.$store.state.user

    UserService.getUserCourses()
      .then(response => {
        this.courses = response
      })
      .catch(() => {
        this.courses = []
      })
      .finally(() => {
        this.coursesLoaded = true
      })

    UserService.getUserResources(this.user.id)
      .then(response => {
        this.resources = response
      })
      .catch(() => {
        this.resources = []
      })
      .finally(() => {
        this.resourcesLoaded = true
      })

    const user = this.$store.state.user
    this.hasManualAccess = Utils.userHasPermission(user, 'super:all') || Utils.userHasPermission(user, 'user:view:manual')

    if (this.hasManualAccess) {
      UserService.getManual()
        .then(response => {
          this.manual = response
        })
        .finally(() => {
          this.manualLoaded = true
        })
    }
  },

  data () {
    return {
      user: {},
      hasManualAccess: false,
      manual: null,
      manualLoaded: false,
      courses: [],
      coursesLoaded: false,
      resources: [],
      resourcesLoaded: false
    }
  },
  computed: {
    ...mapGetters('course', {
      currentLanguageId: 'currentLanguageId'
    })
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

.page-dashboard {

  h3 {
    margin-top: 3rem;
    @include text-size-xl();
    color: $color-text-dark;
  }

  .dashboard-manual,
  .dashboard-courses,
  .dashboard-resources {
    margin-top: 1.5rem;

    &.is-empty {
      padding: 3.5rem;
      text-align: center;
      background-color: $color-gray-lighter;

      .button {
        margin-top: 1.5rem;
      }
    }
  }

  .dashboard-manual,
  .dashboard-course {

    .name {
      margin-bottom: .5rem;
      @include text-size-l();
      font-weight: $font-weight-semibold;
    }

    .card-content:not(:first-child) {
      border-top: 1px solid $color-gray-light;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/DashboardPage.vue